import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import Form from '@gef-ui/form-material/Form';

import { ComponentLoader } from 'components/index';
import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';
import formDescriptorFn, {
	MARKET_PLACE_AGENCIES_SETTINGS_FORM_NAME,
} from 'features/views/settings/marketPlaceAgencies/form';

import ActionButtons from './ActionButtons';
import Agencies from './Agencies';
import FilterControlled from './FilterControlled';
import EditAgencyModal from './modals/EditAgencyModal';
import NotAssignedManagers from './NotAssignedManagers';

export const MarketPlaceAgenciesTab = () => (
	<Form name={MARKET_PLACE_AGENCIES_SETTINGS_FORM_NAME} formDescriptorFn={formDescriptorFn}>
		<EditAgencyModal id={MODALS.agency_detail} />
		<ComponentLoader fetchStorePath={fetch.constants.urls.saveMarketPlaceAgenciesChanges} ignoreErrors>
			<Stack spacing={2}>
				<Paper sx={{ p: 3, borderRadius: 2 }}>
					<Stack spacing={3}>
						<FilterControlled />
						<Agencies />
					</Stack>
				</Paper>
				<NotAssignedManagers />
				<ActionButtons />
			</Stack>
		</ComponentLoader>
	</Form>
);

export default MarketPlaceAgenciesTab;
